import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow } from "date-fns";
import { FileText, Link2, Search, Sparkles } from "lucide-react";

interface Activity {
  id: string;
  type: "capture" | "note" | "research" | "ai_insight";
  title: string;
  timestamp: Date;
}

interface ActivityFeedProps {
  activities: Activity[];
}

const activityIcons = {
  capture: Link2,
  note: FileText,
  research: Search,
  ai_insight: Sparkles,
};

export function ActivityFeed({ activities }: ActivityFeedProps) {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Recent Activity</h3>
      <div className="space-y-4">
        {activities.map((activity) => {
          const Icon = activityIcons[activity.type];
          return (
            <div key={activity.id} className="flex gap-3" data-testid={`activity-${activity.id}`}>
              <div className="flex-shrink-0 mt-1">
                <div className="p-2 bg-muted rounded-lg">
                  <Icon className="h-4 w-4 text-muted-foreground" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium line-clamp-2">{activity.title}</p>
                <p className="text-xs text-muted-foreground mt-1">
                  {formatDistanceToNow(activity.timestamp, { addSuffix: true })}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
